import { Do, fsmData } from '../../universal';
import { $, _ } from '../lib';
export let j2h_count = 0;
const j2h_regexp = /gridRow/;
export const j2h = (obj = {}, modelObj, skipNormalisation = false, recursive = true, topEl) => {
    let $elem;
    j2h_count += 1;
    if (obj === null) {
        const sub_obj = { tag: 'span', text: '' };
        console.warn('Null object given to `j2h`', topEl);
        return j2h(sub_obj, modelObj, skipNormalisation, recursive, topEl);
    }
    topEl = topEl ?? {
        objs: Do(() => {
            if (obj.constructor === Array) {
                return obj;
            }
            return [obj];
        }),
        mapping: new Map(),
    };
    if (obj.constructor === Array) {
        const _j2hConvertArray = (sub_obj) => j2h(sub_obj, modelObj, skipNormalisation, recursive, topEl);
        return _.map(obj, _j2hConvertArray);
    }
    if (!skipNormalisation) {
        obj = j2hNormalise(obj);
    }
    const element = document.createElement(obj.tag ?? 'div');
    const is_grid_row = j2h_regexp.test(obj.class);
    if (obj.class != null) {
        element.className = obj.class;
    }
    const _j2hApplyAttribute = (value, key) => {
        if (value !== undefined) {
            element.setAttribute(key, value);
        }
    };
    _.forEach(obj.attr, _j2hApplyAttribute);
    const _j2hApplyDataAttribute = (value, key) => {
        if (value !== undefined) {
            element.setAttribute(`data-${key}`, value);
        }
    };
    _.forEach(obj.data, _j2hApplyDataAttribute);
    if (obj.value != null) {
        element.value = obj.value;
    }
    const _j2hAppendChildNodes = () => {
        if (obj.text != null) {
            element.textContent = obj.text;
        }
        else if (obj.children != null && recursive) {
            _.forEach(obj.children, child => {
                const childElem = j2h(child, modelObj, skipNormalisation, true, topEl);
                if (is_grid_row) {
                    childElem.className += ' gridCell';
                }
                element.appendChild(childElem);
            });
            return;
        }
        else if (obj.html != null) {
            element.innerHTML = obj.html;
        }
    };
    _j2hAppendChildNodes();
    if (_.size(obj.ev) > 0) {
        $elem = $(element);
        const _j2hApplyEventListener = (func, key) => $elem.on(key, e => func(e, $elem));
        _.forEach(obj.ev, _j2hApplyEventListener);
    }
    const _j2hApplyModelEvents = () => {
        if (!obj.model) {
            return;
        }
        if (modelObj == null) {
            throw Error('No object model defined for this J2H set');
        }
        const non_input = !_.includes(['select', 'input', 'textarea'], obj.tag);
        const defSerialize = (modelVal) => modelVal;
        const defDeserialize = (formVal) => formVal;
        if (typeof obj.model === 'string') {
            obj.model = { field: obj.model };
        }
        if (obj.model.serialize == null) {
            obj.model.serialize = defSerialize;
        }
        if (obj.model.deserialize == null) {
            obj.model.deserialize = defDeserialize;
        }
        let modelVal = modelObj[obj.model.field];
        modelVal = obj.model.serialize(modelVal, element, modelObj);
        element.dataset.model = obj.model.field;
        if (non_input) {
            element.textContent = modelVal;
            return;
        }
        if (obj.attr?.type === 'checkbox') {
            element.checked = !!modelVal;
        }
        else if (obj.tag === 'select' && modelVal == null) {
            element.selectedIndex = -1;
        }
        else {
            element.value = modelVal;
        }
        if ((obj.ev?.change != null || obj.ev?.input != null) &&
            !obj.skipInitValidation) {
            $elem = $(element);
            (obj.ev?.change ?? _.noop)({}, $elem);
            (obj.ev?.input ?? _.noop)({}, $elem);
        }
        const updateModel = (e) => {
            const elem = e.currentTarget;
            let value = Do(() => {
                if (obj.attr?.type === 'checkbox') {
                    return elem.checked;
                }
                else if (obj.tag === 'select' && _.has(obj.attr, 'multiple')) {
                    return fsmData(elem.options, {
                        filter: x => x.selected,
                        map: x => x.value ?? x.text,
                    });
                }
                return elem.value;
            });
            value = obj.model.deserialize(value, element, modelObj);
            modelObj[obj.model.field] = value;
            const modelFieldQuery = `[data-model='${obj.model.field}']`;
            let listeners = [];
            topEl.objs.forEach((topObj) => {
                _.forEach(topObj.el.querySelectorAll(modelFieldQuery), x => {
                    listeners.push(x);
                });
            });
            listeners = listeners.filter(el => el !== obj.el);
            listeners.forEach(el => {
                const listenObj = topEl.mapping.get(el);
                if (listenObj == null) {
                    return;
                }
                const serializedValue = listenObj.model.serialize(value);
                if (_.includes(['input', 'textarea', 'select'], el.tag)) {
                    el.value = serializedValue;
                }
                else {
                    el.textContent = serializedValue;
                }
            });
        };
        $(element).on('input change', e => {
            updateModel(e);
        });
    };
    _j2hApplyModelEvents();
    if (obj.init != null) {
        obj.init(element);
    }
    obj.el = element;
    topEl.mapping.set(obj.el, obj);
    return element;
};
const j2hNormalise = (obj = {}) => {
    if (typeof obj !== 'object') {
        obj = { tag: 'span', text: obj };
    }
    obj.tag = obj.tag != null ? obj.tag.toLowerCase() : 'div';
    {
        if (obj.class == null) {
            obj.class = '';
        }
        if (obj.attr == null) {
            obj.attr = {};
        }
        if (obj.data == null) {
            obj.data = {};
        }
        if (obj.ev == null) {
            obj.ev = {};
        }
    }
    {
        if (obj.key != null) {
            obj.data.key = obj.key;
            delete obj.key;
        }
        if (obj.click != null) {
            obj.ev.click = obj.click;
            delete obj.click;
        }
        if (obj.ev.init != null) {
            obj.init = obj.ev.init;
            delete obj.ev.init;
        }
    }
    {
        if (obj.attr.value !== undefined) {
            obj.value = obj.value;
            delete obj.attr.value;
        }
        if (obj.title != null) {
            obj.attr.title = obj.title;
            delete obj.title;
        }
        if (obj.ID != null) {
            obj.attr.id = obj.ID;
            delete obj.ID;
        }
        if (obj.id != null) {
            obj.attr.id = obj.id;
            delete obj.id;
        }
        if (obj.attr.ID != null) {
            obj.attr.id = obj.attr.ID;
            delete obj.attr.ID;
        }
    }
    {
        _.forEach(obj.data, (v, k) => {
            obj.data[k] = String(v);
        });
        _.forEach(obj.attr, (v, k) => {
            if (v === undefined) {
                delete obj.attr[k];
            }
            else {
                obj.attr[k] = String(v);
            }
        });
    }
    return obj;
};
const j2hNormaliseRecursive = (obj = {}) => {
    obj = j2hNormalise(obj);
    if (obj.children != null) {
        _.forEach(obj.children, (child, index) => {
            obj.children[index] = j2hNormaliseRecursive(child);
        });
    }
    return obj;
};
const j2hReverse = (elem) => {
    const jobj = {
        tag: elem.tagName.toLowerCase(),
        class: '',
        attr: {},
        data: {},
        ev: {},
        children: null,
        text: null,
    };
    _.forEach(elem.attributes, node => {
        let [key, value] = [node.name, node.value];
        if (key === 'id') {
            key = 'ID';
        }
        if (key === 'class') {
            jobj.class = value;
        }
        else if (key.substring(0, 5) === 'data-') {
            jobj.data[key.substring(5)] = value;
        }
        else {
            jobj.attr[key] = value;
        }
    });
    const $withData = $;
    const events = $withData._data?.(elem)?.events ?? {};
    _.forEach(events, (fns, ev) => {
        jobj.ev[ev] =
            fns.length === 1
                ? fns[0]
                : (e, $elem) => {
                    _.forEach(fns, fn => {
                        fn(e, $elem);
                    });
                };
    });
    if (elem.hasChildNodes()) {
        jobj.children = [];
        const raw_children = elem.children;
        _.forEach(_.range(raw_children.length), x => {
            jobj.children.push(j2hReverse(raw_children.item(x)));
        });
    }
    else {
        jobj.text = elem.textContent;
    }
    return jobj;
};
export const j2hRebuild = (rootObj) => {
    const element = rootObj.el;
    const newElement = j2h(rootObj, null, true);
    element.insertAdjacentElement('afterend', newElement);
    element.remove();
    return newElement;
};
//# sourceMappingURL=component-j2h.js.map